// GENERATED FILE. Do not edit by hand. Produced by `bun run codegen`.

import Ajv from "ajv";
import addFormats from "ajv-formats";
import call from "../../sdk-helpers/call";
import { logError } from "../../sdk-helpers/shouldLog";

export type typeContestCorrectionReviewGetBody = {
  poolId: string;
  contestId: string;
};

export type typeContestCorrectionReviewGetOutput200 = {
  error?: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data?: null | {
    contestId: string;
    roundId: string;
    resultsDigest: string;
    reviewToken: string;
    refusalReason: string;
    gradingIncomplete: boolean;
    entries: {
      entryId: string;
      label: string;
      status: "in" | "eliminated" | "revived";
      livesRemaining: number;
      pointsTotal: number;
    }[];
  };
};

export type typeContestCorrectionReviewGetOutput400 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export type typeContestCorrectionReviewGetOutput401 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export type typeContestCorrectionReviewGetOutput500 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export const schemaContestCorrectionReviewGetBody = {
  type: "object",
  properties: {
    poolId: { type: "string", minLength: 1, maxLength: 3000 },
    contestId: { type: "string", minLength: 1, maxLength: 3000 },
  },
  required: ["poolId", "contestId"],
} as const;

export type SdkOptions = {
  headers?: Record<string, string>;
  apiHost?: string;
  prefix?: string;
};

let compiledValidator: ReturnType<Ajv["compile"]> | null = null;

export default function createContestCorrectionReviewGet(options: SdkOptions) {
  if (!compiledValidator) {
    const ajv = new Ajv({ strict: false });
    addFormats(ajv);
    compiledValidator = ajv.compile(schemaContestCorrectionReviewGetBody);
  }

  return async function postContestCorrectionReviewGet(
    payload: typeContestCorrectionReviewGetBody,
  ): Promise<
    | typeContestCorrectionReviewGetOutput200
    | typeContestCorrectionReviewGetOutput400
  > {
    const isValid = compiledValidator!(payload);
    if (!isValid) {
      logError(
        `Payload validation inside SDK method "postContestCorrectionReviewGet" failed before calling the network. #d8fdc380213a`,
        compiledValidator!.errors,
      );
      return {
        error: {
          code: "VALIDATION_ERROR",
          message: "Request payload failed schema validation.",
          details: { errors: compiledValidator!.errors, ref: "#d8fdc380213a" },
        },
        data: null,
      } as typeContestCorrectionReviewGetOutput400;
    }

    const prefix = options?.prefix ?? "";
    return (await call({
      payload,
      endpoint: `${prefix}/contest/correction-review-get`,
      httpMethod: "POST",
      options,
    })) as
      | typeContestCorrectionReviewGetOutput200
      | typeContestCorrectionReviewGetOutput400;
  };
}
